import { useState } from "react";
import ProfileContainer from "../components/ProfileContainer";

const MAX_LENGTH = 4;

const TalentProfileTeams = ({ items }) => {
    const [isMoreOpen, setIsMoreOpen] = useState(false);

    return (
        <div id="teams" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Teams  {!!items?.length && `(${items?.length})`}</h4>

                    {!items?.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Teams Available</p>
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {items?.slice(0, isMoreOpen ? items?.length : MAX_LENGTH).map(
                            item => <TeamDisplay key={item.team.id} team={item.team} />
                        )}
                    </div>

                    {items?.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsMoreOpen(!isMoreOpen)}
                            >
                                <p>{items?.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isMoreOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileTeams;

const TeamDisplay = ({ team }) => {

    const totalMembers = team.positions.length;

    // Adjust sizing based on number of members
    const getSizeClasses = () => {
        switch (totalMembers) {
            case 1:
                return "w-16 h-16"; // 64px for single member
            case 2:
                return "w-14 h-14"; // 56px for two members
            case 3:
                return "w-12 h-12"; // 48px for three members
            default:
                return "w-10 h-10"; // 40px for four or more members
        }
    };

    // Determine layout based on number of members
    const getLayout = () => {
        if (totalMembers <= 3) {
            // All members in a single row for small teams
            return {
                firstRow: team.positions,
                secondRow: []
            };
        }
        // Default layout with two rows
        return {
            firstRow: team.positions.slice(0, 4),
            secondRow: team.positions.slice(4, 7)
        };
    };

    const { firstRow, secondRow } = getLayout();
    const remainingCount = totalMembers > 7 ? totalMembers - 7 : 0;
    const showRemainingCount = remainingCount > 0;
    const sizeClasses = getSizeClasses();

    return (
        <div className="self-stretch h-40 p-3">
            <div className="flex items-center justify-between mb-3">
                <a href={`/team-profiles/${team.id}`} target="_blank" className="flex items-center gap-2 group">
                    <i className="text-xl fa fa-users text-blue-500" />
                    <h2 className="text-xl font-semibold text-gray-900 group-hover:underline">{team.name}</h2>
                </a>
                {/*<span className="text-sm text-gray-500">{team.positions.length} members</span>*/}
            </div>

            <div className="flex gap-3">
                <div className="space-y-2">
                    {/* First row */}
                    <div className="flex -space-x-2">
                        {firstRow.map((member, index) => (
                            <div key={index} className="relative" style={{ zIndex: index + 1 }}>
                                <img
                                    src={member.image_path}
                                    alt={`${member.first_name} ${member.last_name}`}

                                    className={`${sizeClasses} grayscale rounded-full border-1 border-gray-300 object-cover hover:z-10 transition-transform hover:scale-110`}
                                />
                            </div>
                        ))}
                    </div>

                    {/* Second row - only shown if there are more than 3 members */}
                    {secondRow.length > 0 && (
                        <div className="flex -space-x-2">
                            {secondRow.map((member, index) => (
                                <div key={index} className="relative" style={{ zIndex: index + 1 }}>
                                    <img
                                        src={member.image_path}
                                        alt={`${member.first_name} ${member.last_name}`}

                                        className={`${sizeClasses} grayscale rounded-full border-1 border-gray-300 object-cover hover:z-10 transition-transform hover:scale-110`}
                                    />
                                </div>
                            ))}
                            {showRemainingCount && (
                                <div style={{ zIndex: secondRow?.length + 2 }} className={`${sizeClasses} rounded-full border-1 border-gray-300 bg-gray-100 flex items-center justify-center text-xs font-medium text-gray-600`}>
                                    +{remainingCount}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-gray-900 line-clamp-2 max-w-full">
                        {team.positions.map(m => m.first_name).join(', ')}
                    </p>
                    <p className="text-xs text-gray-500">
                        {totalMembers > 7
                            ? `7 of ${totalMembers} members shown`
                            : `${totalMembers} team members`}
                    </p>
                </div>
            </div>
        </div>
    );
}